module.exports = __webpack_public_path__ + "img/swimming-pool.b3574fd3.svg";